const config: siteConfig = {
  // Softdigi endpoint
  // API_URL: "https://hrms.softdigisolutions.com/api/",
 //  API_URL: "http://192.168.1.38/softdigisolutions/sd_examination_backend/api/",
  API_URL: "https://exam.tthefl.com/api/",
  //API_URL: "http://10.19.1.74/sds_hrms_backend/api",
};

export default config;
